import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';

import { IUsers } from '../database';
//import { LoginService  } from '../login/login.service';
@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router/*,public _loginService:LoginService*/) {}
  canActivate() {
    if (localStorage.getItem('UserInfo')!=null) {
      //this._loginService.setCurrentUser( JSON.parse(localStorage.getItem('UserInfo')));
      return true;
    }
    this.router.navigate(['login']);
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/common/auth.guard.ts